<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="请选择机构" prop="organizationId" >
        <a-select v-model="form.organizationId" placeholder="请选择机构" allow-clear>
          <a-select-option v-for="item in organizationList" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="教师名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入教师名称" />
      </a-form-model-item>
      <a-form-model-item label="教师图片" prop="picture" >
        <file-upload type="image" :defaultList="form.imgArr" :count="form.pictureCount" @click=""
                     @input="getImg($event, 'picture')"></file-upload>
      </a-form-model-item>
      <a-form-model-item label="教师标签" prop="labelIds" >
        <a-select
          mode="multiple"
          v-model="form.labelIds"
          placeholder="请选择教师标签"
          allow-clear
          style="width: 100%"
        >
          <a-select-option v-for="item in teacherLabelList" :key="item.id" :value="item.dictLabel" >
            {{ item.dictLabel }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="教师简介" prop="introduction" >
        <a-input v-model="form.introduction" placeholder="请输入教师简介" />
      </a-form-model-item>
      <a-form-model-item label="教师介绍" prop="content" >
        <editor
          v-if="open"
          v-model="form.content"
          :key="'teacher-content-' + (form.id != null ? form.id : editorKey)"
        />
      </a-form-model-item>
      <a-form-model-item label="教师访谈视频" prop="video" >
        <file-upload type="file" :defaultList="form.videoArr" :count="form.videoCount" @click=""
                     @input="getImg($event, 'video')"></file-upload>
        <video
          v-if="form.video"
          style="width: 180px; height: 120px"
          class="avatar video-avatar"
          controls="controls"
          :src="form.videoArr[0].url"
        />

      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTeacher, addTeacher, updateTeacher } from '@/api/teacher/teacher'
import Editor from '@/components/Editor'
import {listOrganization} from "@/api/organization/organization";
import {getDicts} from "@/api/system/dict/data";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      editorKey: 0,
      organizationList: [],
      teacherLabelList: [], // 教师标签字典列表
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        organizationId: null,

        name: null,

        picture: null,
        pictureCount: 1,
        imgArr: [], // 图片数组用于回显

        label: null,
        labelIds: [], // 用于多选下拉的数组

        introduction: null,

        content: '',

        video: null,
        videoArr: [], // 视频数组用于回显
        videoCount: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '教师名称不能为空', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '教师图片不能为空', trigger: 'blur' }
        ],
        labelIds: [
          {
            required: true,
            message: '教师标签不能为空',
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('教师标签不能为空'))
              } else {
                callback()
              }
            }
          }
        ],
        introduction: [
          { required: true, message: '教师简介不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '教师介绍不能为空', trigger: 'blur' }
        ],
        video: [
          { required: true, message: '教师访谈视频不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        organizationId: null,
        name: null,
        picture: null,
        imgArr: [], // 重置图片数组
        label: null,
        labelIds: [], // 重置数组
        introduction: null,
        content: '',
        video: null,
        videoArr: [], // 重置视频数组
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    getOrganizationList () {
      listOrganization().then(response => {
        this.organizationList = response.data
      })
    },
    /** 获取教师标签字典数据 */
    getTeacherLabelList () {
      getDicts('teacher_label').then(response => {
        this.teacherLabelList = response.data || []
      }).catch(() => {
        this.teacherLabelList = []
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
      this.editorKey++
      // 先获取字典数据
      this.getOrganizationList()
      this.getTeacherLabelList()
      // 使用 $nextTick 确保数据加载后再打开 drawer
      this.$nextTick(() => {
        this.open = true
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      // 先获取字典数据，确保数据加载完成后再获取教师数据
      Promise.all([
        new Promise((resolve) => {
          listOrganization().then(response => {
            this.organizationList = response.data || []
            resolve()
          }).catch(() => {
            this.organizationList = []
            resolve()
          })
        }),
        new Promise((resolve) => {
          getDicts('teacher_label').then(response => {
            this.teacherLabelList = response.data || []
            resolve()
          }).catch(() => {
            this.teacherLabelList = []
            resolve()
          })
        })
      ]).then(() => {
        return getTeacher({"id":id})
      }).then(response => {
        const data = response.data || {}
        // 先赋值基础数据
        this.form.id = data.id
        this.form.organizationId = data.organizationId
        this.form.name = data.name
        this.form.picture = data.picture
        this.form.label = data.label
        this.form.introduction = data.introduction
        this.form.content = data.content || ''
        this.form.video = data.video
        this.form.createTime = data.createTime
        this.form.remark = data.remark

        // 处理图片回显
        if (this.form.picture) {
          this.form.imgArr = [{
            uid: Date.now(),
            name: this.form.picture.split('/').pop() || 'image',
            status: 'done',
            url: this.form.picture,
            path: this.form.picture
          }]
        } else {
          this.form.imgArr = []
        }

        // 处理视频回显
        if (this.form.video) {
          this.form.videoArr = [{
            uid: Date.now(),
            name: this.form.video.split('/').pop() || 'video',
            status: 'done',
            url: this.form.video,
            path: this.form.video
          }]
        } else {
          this.form.videoArr = []
        }

        // 将逗号分隔的字符串转换为数组
        // 此时字典数据已经加载完成，label 中存储的是字典 id，多个用逗号分隔
        if (this.form.label) {
          const labelArray = this.form.label.split(',').map(item => item.trim()).filter(item => item)
          // 将id转换为对应的名称进行回显
          const labelNames = []
          labelArray.forEach(labelValue => {
            // 在字典列表中查找对应的项，使用 dictValue 匹配（参考列表页的匹配方式）
            // 使用 == 进行宽松匹配，可以自动处理类型转换
            const dictItem = this.teacherLabelList.find(item => {
              return item.dictValue == labelValue || String(item.dictValue) === String(labelValue)
            })
            if (dictItem && dictItem.dictLabel) {
              labelNames.push(String(dictItem.dictLabel).trim())
              return
            }
            // 如果 dictValue 匹配不到，尝试用 id 匹配
            const dictItemById = this.teacherLabelList.find(item => {
              return item.id == labelValue || String(item.id) === String(labelValue)
            })
            if (dictItemById && dictItemById.dictLabel) {
              labelNames.push(String(dictItemById.dictLabel).trim())
              return
            }
            // 如果都匹配不到，说明可能是名称，直接返回
            labelNames.push(String(labelValue).trim())
          })
          // 使用 Vue.set 确保响应式更新
          this.$set(this.form, 'labelIds', labelNames)
        } else {
          this.$set(this.form, 'labelIds', [])
        }

        this.formTitle = '修改'
        this.editorKey++
        // 使用 $nextTick 确保数据设置后再打开 drawer
        this.$nextTick(() => {
          this.open = true
          // 重置表单验证状态
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      }).catch(() => {
        this.$message.error('获取教师信息失败')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          // 将名称数组转换为id字符串
          if (this.form.labelIds && this.form.labelIds.length > 0) {
            const labelIds = this.form.labelIds.map(labelName => {
              // 如果已经是id（数字或字符串），直接返回
              if (typeof labelName === 'number' || (typeof labelName === 'string' && /^\d+$/.test(labelName))) {
                return labelName
              }
              // 否则在字典列表中查找对应的id（优先使用 dictValue）
              const dictItem = this.teacherLabelList.find(item => item.dictLabel === labelName)
              return dictItem ? (dictItem.dictValue || dictItem.id) : labelName
            })
            this.form.label = labelIds.join(',')
          } else {
            this.form.label = ''
          }

          if (this.form.id !== undefined && this.form.id !== null) {
            updateTeacher(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.reset()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addTeacher(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.reset()
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
